import { ChangeEvent, FC } from 'react';
import { forceVisible } from 'react-lazyload';
// i18next
import { useTranslation } from 'react-i18next';
// Store
import { useDispatch, useSelector } from 'react-redux';
// Actions
import { EpisodesActions } from 'app/store/Episodes/Episodes.slice';
// Selectors
import { selectAllEpisodeAuthorsAsOptions, selectAllEpisodeLabelsAsOptions, selectAllEpisodeTypesAsOptions, selectEpisodesFilters } from 'app/store/Episodes/Episodes.selectors';
// Mui
import { Box } from '@mui/material';
// Components
// import TagPicker from 'app/components/TagPicker';
import ColorPalette from 'app/components/ColorPalette';
import { Select } from 'app/components/Mui';
import { Autocomplete } from 'app/components/Mui/Autocompletes';

const EpisodesFilters:FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const labelsOptions = useSelector(selectAllEpisodeLabelsAsOptions);
  const typesOptions = useSelector(selectAllEpisodeTypesAsOptions);
  const authorsOptions = useSelector(selectAllEpisodeAuthorsAsOptions);
  const filters = useSelector(selectEpisodesFilters);

  const handleChange = (field:any) => (value:any) => {
    dispatch(EpisodesActions.setEpisodesFilters({ field, value }));
    forceVisible();
  }
  
  // const handleClickTag = (nextTag:string | null) => {
  //   const idx = filters.tags.indexOf(nextTag);
  //   const nextTags = idx !== -1 ? filters.tags.filter((_:any, i:number) => i !== idx) : [...filters.tags, nextTag];
  //   dispatch(EpisodesActions.setEpisodesFilters({ field: 'tags', value: nextTags }));
  //   forceVisible();
  // }
  
  const handleColorClick = (newColor:string) => {
    const idx = filters.colors.indexOf(newColor);
    const nextColors = idx !== -1 ? filters.colors.filter((_:any, i:number) => i !== idx) : [...filters.colors, newColor];
    dispatch(EpisodesActions.setEpisodesFilters({ field: 'colors', value: nextColors }));
    forceVisible();
  }

  const handleInWorkspaceChange = (event:ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    dispatch(EpisodesActions.setEpisodesFilters({ field: 'inWorkspace', value }));
    forceVisible();
  }

  const workspaceOptions = [
    { id: 'all', name: t('labels.all') },
    { id: 'true', name: t('labels.isInWorkspace') },
    { id: 'false', name: t('labels.notInWorkspace') }
  ];

  return (
    <Box sx={{ py: 2, px: 4, display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2, mb: 2 }}>
      <Box sx={{ width: 320 }}>
        <Autocomplete
          size="small"
          multiple
          value={filters.authors}
          onChange={handleChange('authors')}
          options={authorsOptions || []}
          TextFieldProps={{
            label: t('labels.authors'),
            margin: 'none'
          }}
        />
      </Box>
      <Box sx={{ width: 320 }}>
        <Autocomplete
          size="small"
          multiple
          value={filters.labels}
          onChange={handleChange('labels')}
          options={labelsOptions || []}
          TextFieldProps={{
            label: t('labels.labels'),
            margin: 'none'
          }}
        />
      </Box>
      <Box sx={{ width: 320 }}>
        <Autocomplete
          size="small"
          multiple
          value={filters.types}
          onChange={handleChange('types')}
          options={typesOptions || []}
          TextFieldProps={{
            label: t('labels.types'),
            margin: 'none'
          }}
        />
      </Box>
      <Box sx={{ width: 180 }}>
        <Select
          label={t('pages.authorRegistry.inWorkspace')} name="inWorkspace" value={filters.inWorkspace}
          onChange={handleInWorkspaceChange}
          options={workspaceOptions}
          size="small"
          margin="none"
        />
      </Box>
      {/* <Box>
        <TagPicker
          id="Episodes tag filter"
          activeTags={filters.tags}
          noTagVisible={true}
          onClick={handleClickTag}
        />
      </Box> */}
      <ColorPalette activeColors={filters.colors}>
        {(color) => (
          <ColorPalette.Item
            key={color}
            color={color}
            onClick={handleColorClick}
          />
        )}
      </ColorPalette>
    </Box>
  )
}

export default EpisodesFilters;